import { render } from "./face-detection-view.vue?vue&type=template&id=054a2034&scoped=true"
import script from "./face-detection-view.vue?vue&type=script&lang=js"
export * from "./face-detection-view.vue?vue&type=script&lang=js"

import "./face-detection-view.vue?vue&type=style&index=0&id=054a2034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a2034"]])

export default __exports__